import { ReactElement, useContext } from 'react'

import { TextProps } from '@hhgtech/hhg-components/mantine'

import { ChatContainer, ChatContainerProps } from './chatContainer'
import { ConversationHeader } from './converationHeader'
import useStyles from './index.styles'
import { MessageList } from './messageList'
import { StarterBox } from './utils/starterBox'
import { AIChatBotContext } from '../context'

export type WidgetProps = {
  headingTag?: ReactElement<TextProps>
} & Partial<ChatContainerProps>

export const Widget = ({
  headingTag,
  styles,
  classNames,
  onClose,
  ...boxProps
}: WidgetProps) => {
  const { messageList, setMessageList, expandWidget } = useContext(
    AIChatBotContext,
  )
  const { classes } = useStyles(
    { expandWidget },
    {
      name: 'AIChatBot__Widget',
      styles,
      classNames,
    },
  )

  return (
    <ChatContainer
      classNames={{
        root: classes.root,
      }}
      header={
        <ConversationHeader
          headingTag={headingTag}
          onClose={onClose}
          className={classes.header}
        />
      }
      {...boxProps}
    >
      {messageList !== null ? (
        <MessageList
          classNames={{
            action: classes.action,
            scrollBody: classes.scrollBody,
          }}
        />
      ) : (
        <StarterBox
          onStart={(message) => {
            setMessageList([message])
          }}
          classNames={{
            action: classes.action,
            root: classes.starterBox,
            scrollBody: classes.scrollBody,
          }}
        />
      )}
    </ChatContainer>
  )
}
